import { render } from "./Footer.vue?vue&type=template&id=67ba6e66"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=67ba6e66&lang=css"
script.render = render

export default script